import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  TextField,
} from "@material-ui/core";
import TextEditorComponent from "../textEditor/TextEditor";
import ImageUpload from "../../containers/upload/imageUpload";
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    padding: "3vh 3%",
    "@media (max-width: 600px)": {
      padding: "3vh 0%",
      marginLeft: "-15px",
      width: "109%",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
  },
  cardActions: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "15px",
  },
  title: {
    margin: "10px 0",
  },
  input: {
    margin: "10px 0",
  },
}));

export default ({ title, onSubmit, openToast, isLoading, baseContentData }) => {
  const classes = useStyles();
  const [state, setState] = useState(
    baseContentData._id
      ? {
          title: baseContentData.title,
          summary: baseContentData.summary,
          imageUrl: baseContentData.coverPhoto,
          fileUrl: baseContentData.pdfUrl,
        }
      : {
          title: "",
          summary: "",
          imageUrl: null,
          fileUrl: null,
        }
  );
  const handleChange = (event) => {
    const { id, value } = event.target;

    setState({ ...state, [id]: value });
  };
  const handleImageUploaded = (imageUrl) =>
    setState((prevState) => ({ ...prevState, imageUrl }));

  const handleFileUploaded = (fileUrl) =>
    setState((prevState) => ({ ...prevState, fileUrl }));

  const handleSubmit = () => onSubmit(state);
  return (
    <Container justify="center" maxWidth="md">
      <Card className={classes.cardRoot}>
        <CardHeader title={title || "Article Form"} />
        <CardContent className={classes.cardContent}>
          <TextField
            id="title"
            label="Title"
            variant="outlined"
            className={classes.title}
            value={state.title}
            onChange={handleChange}
            required
          />
          <TextField
            id="summary"
            label="Summary"
            multiline
            rows={4}
            value={state.summary}
            onChange={handleChange}
            variant="outlined"
            className={classes.input}
          />
          <Typography>Cover photo *</Typography>
          <ImageUpload
            isSmall
            defaultImg={state.imageUrl}
            onFileUploaded={handleImageUploaded}
          />
          <br />
          <div className={classes.input}>
            <Typography>PDF *</Typography>
            <ImageUpload
              onFileUploaded={handleFileUploaded}
              isFileUpload
              defaultImg={state.fileUrl}
              destination="newsletters"
            />
          </div>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button
            variant="outlined"
            onClick={handleSubmit}
            sx={{
              color: "#E00186",
              border: "1px solid #E00186",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#E00186",
                border: "1px solid #E00186",
              },
            }}
          >
            {isLoading ? "Saving..." : "Save Work"}
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
};
